import styled from "styled-components";
import { theme } from "../theme";

export const StyledDescription = styled.p`
	font-size: 2.2rem;
	font-weight: 700;
	font-family: ${theme.font.primary};
`;
